var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.$route.path,attrs:{"id":"app"}},[_c('HeaderSection'),_c('router-view'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }